import { api } from "@lumberset/api-client";
import { HelpArticleEditor, staffArticlesQuery } from "@lumberset/support-ui";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../../components/crumbs";

/** A new article, blank or drafted from a Ticket (`?ticketId=`). */
export const Route = createFileRoute("/_app/help/articles/new")({
  validateSearch: (search: Record<string, unknown>): { ticketId?: string } =>
    typeof search.ticketId === "string" && search.ticketId ? { ticketId: search.ticketId } : {},
  component: NewArticle,
});

function NewArticle() {
  const { ticketId } = Route.useSearch();
  const navigate = useNavigate();
  const { data } = useQuery(staffArticlesQuery(api));
  const categories = [...new Set((data?.articles ?? []).map((article) => article.category))];

  return (
    <>
      <Crumbs
        trail={[{ label: "Help articles", to: "/help/articles" }, { label: "New article" }]}
      />
      <HelpArticleEditor
        api={api}
        ticketId={ticketId}
        categories={categories}
        onSaved={(article) => navigate({ to: "/help/articles/$id", params: { id: article.id } })}
      />
    </>
  );
}
